
import StatusChip from "./StatusChip"
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

export const GetStatusChip = (props: any) => {
    const row = props?.data
    const column = props?.column?.colId

    type status = null | "TrainingInProgress" | "TrainingComplete";
    type outputStatus = "notstarted" | "traininginprogress" | "completed"

    const renderState = (status: status): outputStatus => {
        switch (status) {
        case null:
            return "notstarted"
        case "TrainingInProgress":
            return "traininginprogress"
        case "TrainingComplete":
            return "completed"
        }
    }

    if(column === "ducStatus"){
        if (row?.isRemoved === true){
            return <StatusChip state ="revoked"/>
        }

        if(row?.isCancelled === true){
            return <StatusChip state ="cancelled"/>
        }else{
            return <StatusChip state= {props?.value.toLowerCase()} declined_by={row?.declined_by}/>
        }
    }
    else {
        return <StatusChip state= {renderState(props.value)}/>
    }

}

export const GetRevoked = (props: any) => {
    const row = props?.data
    const hasActiveTransfer = props?.context?.hasActiveTransfer
    if(row?.isRemoved === true){
        return <DeleteForeverOutlinedIcon color="disabled"/>
    }
    // A sub-applicant left over from a cancelled ownership transfer (isCancelled) points at the
    // original PI's still-valid relationship, not this PI's - revoking it here would incorrectly
    // revoke that PI's access. Keep the row visible (see GetStatusChip's "cancelled" chip) but
    // block the destructive action.
    if(row?.isCancelled === true){
        return <DeleteForeverOutlinedIcon color="disabled"/>
    }
    // "TrainingComplete" is a real users_duc_access.duc_status value for a sub-applicant who has
    // finished their own post-approval training - their access is just as active as "Approved", so
    // the PI must still be able to revoke it.
    if((row?.ducStatus === "Approved" || row?.ducStatus === "TrainingComplete") && !hasActiveTransfer){
        return <DeleteForeverOutlinedIcon/>
    }
    else{
        return <DeleteForeverOutlinedIcon color="disabled"/>
    }
}
